import type { PromocodeDataFromBackend, PromoValues } from './types';

import { URL } from '../../constants';
import { httpApiService } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

export const checkPromo = (requestData: PromoValues) => {
  type AdapterProps = { request: typeof requestData; response: PromocodeDataFromBackend };

  return defaultRequestService<AdapterProps>(URL.CHECK_PROMO_COD, httpApiService.post, {
    requestData,
  });
};
